export default __webpack_public_path__ + "static/media/imageError.3a4acd2d.svg";